import { getTime, timeDifference } from '../../../utils/TimeUtils';
import { isEmpty } from 'lodash';
import Api from '../../../api/Api';
import Logger from '../../../utils/Logger';
import { TIMELINE } from '../../../data/reducer';
import {
  selectNotificationData,
  selectUpcomingAndPastEvents,
} from './selector';
import CallQueue from '../../../api/CallQueue';
import { showGTI } from '../../../data/service/gti/actions';
import {
  clearLinkCache,
  doGetLink,
} from '../../../data/linkkipalvelu/actions';
import { getDepartmentabbreviation } from '../../../utils/TimelineUtils';
import Urls from '../../../definitions/Urls';
import { getGtiAppointment } from '../../../data/util';
import {
  receivedQuestionnaires,
  requestQuestionnaires,
  requestQuestionnairesFailed,
} from '../../../data/questionnaires/actions';
import ApiError from '../../../api/ApiError';
import {navigateToTimelineFrame} from "../../timelineframe/data/actions";

const createActionName =
  require('../../../data/util').createActionName('timeline');

const { id: module_id } = module;
const logger = Logger(module_id);

export const REQUEST_TIMELINE_EVENTS = createActionName(
  'REQUEST_TIMELINE_EVENTS'
);
export const REQUEST_TIMELINE_EVENTS_FAILED = createActionName(
  'REQUEST_TIMELINE_EVENTS_FAILED'
);
export const RECEIVE_TIMELINE_EVENTS = createActionName(
  'RECEIVE_TIMELINE_EVENTS'
);

export const REQUEST_APPROVE_TIMELINE_EVENT = createActionName(
  'REQUEST_APPROVE_TIMELINE_EVENT'
);
export const REQUEST_APPROVE_TIMELINE_EVENT_FAILED = createActionName(
  'REQUEST_APPROVE_TIMELINE_EVENT_FAILED'
);
export const TOGGLE_PAST_EVENTS = createActionName('TOGGLE_PAST_EVENTS');
export const SET_SHOW_PAST_EVENTS = createActionName('SET_SHOW_PAST_EVENTS');
export const SHOW_MORE_PAST_EVENTS = createActionName('SHOW_MORE_PAST_EVENTS');

export const SHOW_RESCHEDULE_TRANSITION_MODAL = createActionName(
  'SHOW_RESCHEDULE_TRANSITION_MODAL'
);
export const HIDE_RESCHEDULE_TRANSITION_MODAL = createActionName(
  'HIDE_RESCHEDULE_TRANSITION_MODAL'
);

export const SHOW_TIMELINE_MODAL = createActionName('SHOW_TIMELINE_MODAL');
export const HIDE_TIMELINE_MODAL = createActionName('HIDE_TIMELINE_MODAL');

export const ASSIGN_QUESTIONNAIRE = createActionName('ASSIGN_QUESTIONNAIRE');
export const ASSIGN_QUESTIONNAIRE_SUCCESS = createActionName(
  'ASSIGN_QUESTIONNAIRE_SUCCESS'
);
export const ASSIGN_QUESTIONNAIRE_FAILED = createActionName(
  'ASSIGN_QUESTIONNAIRE_FAILED'
);

const cc = new CallQueue();

/*
 * Timeline actions:
 * request timeline events
 * approve a timeline event reservation
 * */
export const requestTimelineEvents = () => ({
  type: REQUEST_TIMELINE_EVENTS,
});

export const requestTimelineEventsFailed = (error) => ({
  type: REQUEST_TIMELINE_EVENTS_FAILED,
  error: error,
});

export const receiveTimelineEvents = (data) => ({
  type: RECEIVE_TIMELINE_EVENTS,
  data: data,
});

export const requestApproveTimelineEvent = () => ({
  type: REQUEST_APPROVE_TIMELINE_EVENT,
});

export const requestApproveTimelineEventFailed = (error) => ({
  type: REQUEST_APPROVE_TIMELINE_EVENT_FAILED,
});

export const togglePastEvents = () => ({
  type: TOGGLE_PAST_EVENTS,
});

export const setShowPastEvents = (value) => ({
  type: SET_SHOW_PAST_EVENTS,
  value,
});

export const showMorePastEvents = () => ({
  type: SHOW_MORE_PAST_EVENTS,
});

/*
 * Show modal when transitioning from timeline notification's reschedule button
 * */
export const showRescheduleTransitionModal = (notificationId) => ({
  type: SHOW_RESCHEDULE_TRANSITION_MODAL,
  notificationId: notificationId,
});

export const hideRescheduleTransitionModal = () => ({
  type: HIDE_RESCHEDULE_TRANSITION_MODAL,
});

export const showTimelineModal = () => ({
  type: SHOW_TIMELINE_MODAL,
});

export const hideTimelineModal = () => ({
  type: HIDE_TIMELINE_MODAL,
});

export const assignQuestionnaire = () => ({
  type: ASSIGN_QUESTIONNAIRE,
});

export const assignQuestionnaireSuccess = () => ({
  type: ASSIGN_QUESTIONNAIRE_SUCCESS,
});

export const assignQuestionnaireFailed = (error) => ({
  type: ASSIGN_QUESTIONNAIRE_FAILED,
  error: error,
});

export const updateTimelineShowPastEvents = () => (dispatch, getState) => {
  let events = selectUpcomingAndPastEvents(getState());
  let notifications = selectNotificationData(getState());

  if (
    !events.isFetching &&
    !events.error &&
    !notifications.isFetching &&
    !notifications.error
  ) {
    if (
      isEmpty(notifications.notifications) &&
      isEmpty(events.upcomingEvents) &&
      !isEmpty(events.pastEvents)
    ) {
      logger.debug('calling toggle past events', events);
      dispatch(setShowPastEvents(true));
    } else {
      logger.debug('not calling toggle past events', events);
    }
  } else {
    logger.debug('response is fetching or has error', events);
  }
};

const createApiError = (errorData) => {
  let error = new ApiError({
    code: errorData.errorCode,
    msg: errorData.message,
    url: '',
  });
  logger.error(error);
  return error;
};

export const getTimelineEventsAndQuestionnaires =
  () => (dispatch, getState, services) => {
    return new Promise((resolve, reject) => {
      dispatch(requestTimelineEvents());
      dispatch(requestQuestionnaires());

      services.api
        .getTimelineAndQuestionnaires()
        .then((data) => {
          let { timeline, questionnaires } = data;

          if (timeline.status !== 'SUCCESS') {
            console.log("timeline status was not 'SUCCESS'");
            dispatch(requestTimelineEventsFailed(createApiError(timeline)));
          } else {
            dispatch(processTimelineSuccess(timeline.payload));
          }

          if (questionnaires.status !== 'SUCCESS') {
            dispatch(
              requestQuestionnairesFailed(createApiError(questionnaires))
            );
          } else {
            dispatch(receivedQuestionnaires(questionnaires.payload));
          }

          return resolve(data);
        })
        .catch((error) => {
          console.error(
            'error while fetching timeline and questionnaires',
            error
          );
          dispatch(requestTimelineEventsFailed(error));
          dispatch(requestQuestionnairesFailed(error));
          return reject();
        });
    });
  };

export const getTimelineEvents = (force) => (dispatch, getState, services) => {
  let request = () =>
    new Promise((resolve, reject) => {
      let prevState = getState()[TIMELINE];
      let { lastFetch } = prevState;
      let dataIsStale =
        !lastFetch ||
        timeDifference(getTime(), lastFetch, 5) ||
        prevState.error;

      dispatch(requestTimelineEvents());

      if (force || dataIsStale) {
        dispatch(clearLinkCache('Toimipistetiedot'));
        return Api.getTimelineEvents()
          .then((data) => {
            dispatch(processTimelineSuccess(data));
            resolve();
          })
          .catch((error) => {
            console.error('got error while fetching', { error });
            reject(dispatch(requestTimelineEventsFailed(error)));
          });
      } else {
        return resolve(dispatch(receiveTimelineEvents(prevState.data)));
      }
    });

  return cc.attach('getTimelineEvents', request);
};

const processTimelineSuccess = (data) => (dispatch) => {
  let gtiStatus = data.gtiStatus;
  if (gtiStatus === 'GTI_ACTIVE') {
    dispatch(showGTI(getGtiAppointment(data.timelineEvents)));
  }
  dispatch(receiveTimelineEvents(data.timelineEvents));
  dispatch(doGetLink('Ohjeet', 'common'));
  dispatch(doGetLink('Ohjeet', 'coxa'));
  data.timelineEvents.forEach((element) => {
    let departmentAbbreviation = getDepartmentabbreviation(element.department);
    if (departmentAbbreviation != null) {
      dispatch(doGetLink('Toimipistetiedot', departmentAbbreviation));
    }
    dispatch(doGetLink('Logot', element.oid));
  });
};

export const approveTimelineEvent = (appointmentId) => (dispatch, getState) => {
  dispatch(requestApproveTimelineEvent());
  let applicableItems = getState()[TIMELINE].data;
  let applicableEvents = applicableItems.filter(
    (item) => item.id === appointmentId
  );
  if (applicableEvents.length !== 1) {
    logger.error('Multiple applicable timeline reservation events found');
    return;
  }
  return Api.approveTimelineEvent({ ...applicableEvents[0] })
    .then((data) => {
      dispatch(receiveTimelineEvents(data.timelineEvents));
      dispatch(navigateToTimelineFrame(appointmentId));
    })
    .catch((error) => {
      dispatch(requestApproveTimelineEventFailed(error));
    });
};

export const setReferralNotified = (referralId) => (dispatch) => {
  return Api.setReferralNotified({ payload: referralId }).
  then((data) => {
      dispatch(receiveTimelineEvents(data.timelineEvents));
  })
};

export const navigateToReschedule = (appointmentId, history) => (dispatch) => {
  dispatch(hideRescheduleTransitionModal());
  history.push(`/appointments/reschedule/${appointmentId}`);
};

// FIXME: Arguments(3)
const redirectToQuestionnaire = (questionnaireId) => (dispatch) => {
  dispatch(assignQuestionnaireSuccess());
  window.location = `${Urls.baseUrl()}#/questionnaires/${questionnaireId}`;
};

export const doAssignQuestionnaire = () => (dispatch, getState, services) => {
  dispatch(assignQuestionnaire());
  return new Promise((resolve, reject) => {
    Api.assignQuestionnaire()
      .then((data) => {
        console.log({ data });
        dispatch(redirectToQuestionnaire(data));
      })
      .catch((error) => {
        dispatch(assignQuestionnaireFailed(error));
      });
  });
};
